export default {
  emits: ['change'],

  computed: {
    viewFormattedFilter() {
      if (this.validRange() && this.notInitialValues) {
        return `${this.lowerEdgeTooltip}-${this.higherEdgeTooltip}`
      } else {
        return ''
      }
    },

    lowerEdgeTooltip() {
      return this.$n(this.lowerEdge)
    },

    higherEdgeTooltip() {
      if (this.higherEdge == '-1') {
        return "∞"
      } else {
        return this.$n(this.higherEdge)
      }
    },

    maxValue() {
      if (this.higherEdge == '-1') {
        return Math.max(...Object.keys(this.selectHigherEdge))
      } else {
        return this.higherEdge
      }
    },

    formattedRange() {
      return {
        min: Number(this.lowerEdge),
        max: Number(this.higherEdge)
      }
    },
    
    notInitialValues() {
      return this.lowerEdge != 0 || this.higherEdge != -1
    },
  },

  methods: {
    // bootstrap-vue-next's b-form-select takes an array; keep the object's key order and string values
    toOptions(options) {
      return Object.entries(options).map(([value, text]) => ({ value, text }))
    },

    validateSearchResult() {
      if (this.validRange()) {
        this.viewSearchResults(this.formattedRange)
      }
    },

    changedFilter() {
      if (this.validRange()) {
        this.$emit('change', this.formattedRange)
      }
    },

    validRange() {
      if (this.validMin() && this.validMax() && this.notSameValues()) {
        this.errorMessage = ''
        return true
      } else {
        this.errorMessage = this.$t('competitors_filters.higher_edge_should_be_more_than_lower_edge')
        return false
      }
    },

    validMin() {
      return Number(this.lowerEdge) <= Number(this.maxValue)
    },

    validMax() {
      return Number(this.maxValue) >= Number(this.lowerEdge)
    },

    notSameValues() {
      return this.lowerEdge != this.higherEdge
    }
  }
}
